module.exports = __webpack_public_path__ + "static/media/Sec-4_Banner_TH_Mobile.a5b97d6b.png";